module.exports = __webpack_public_path__ + "static/img/encyclopedia.ceab0e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jpg/encyclopedia.jpg
// module id = 190
// module chunks = 0